<template>
  <div class="bo-wrapper" :class="computer ? 'bo-wrapper-pc' : ''" @click="handlePageClick">
    <header class="ant-layout-header">
      <div class="left">
        BOBO公式
      </div>

      <div class="right">
        <div class="select" data-select="1" @click="showSelectList = !showSelectList">
          <div data-select="1">{{ renderSelectMode }}</div>
          <div data-select="1" class="select-icon"></div>
        </div>
        <div data-select="1" class="select-list" :class="{ 'show': showSelectList }">
          <div data-select="1" @click="handleSelectMode('1')" :class="{ 'active': selectMode === '1' }">公式一(常规眼)
          </div>
          <div data-select="1" @click="handleSelectMode('2')" :class="{ 'active': selectMode === '2' }">公式二(屈光术后)
          </div>
        </div>
      </div>

    </header>
    <a-layout-content style="padding: 0 20px">
      <a-form class="custom-form" ref="formRef" :model="formState" :rules="rules"
        :label-col="{ style: { width: computer ? '1.04rem' : '150px' } }"
        :wrapper-col="{ style: { width: computer ? '1.50rem' : '250px' } }" layout="inline" labelAlign="left"
        :colon="false">
        <div class="user-info" v-if="computer">
          <div>
            患者姓名(Name):
            <a-input v-model:value="formState.name" placeholder="患者姓名(Name)" />
          </div>
          <div>
            患者年龄(Age):
            <a-input v-model:value="formState.age" placeholder="患者年龄(Age)" />
          </div>
          <div>
            患者ID:
            <a-input v-model:value="formState.id" placeholder="患者ID" />
          </div>
          <div>
            医生(Surgeon):
            <a-input v-model:value="formState.Surgeon" placeholder="医生(Surgeon)" />
          </div>
        </div>

        <a-divider v-if="computer"></a-divider>

        <div class="params-wrapper">
          <div class="params-space">
            <div class="eye" v-if="computer">右眼 <span>(OD)</span></div>
            <a-divider orientation="left" v-else>右眼(OD)</a-divider>
            <a-form-item label="屈光指数(Index)" required>
              <a-input v-model:value="formState.refractiveIndex" disabled />
            </a-form-item>
            <a-form-item label="眼轴长(L)" name="odal">
              <a-input v-model:value="formState.odal" placeholder="光学眼轴长" suffix="mm" />
            </a-form-item>
            <a-form-item label="K值(K1)" name="odk1">
              <a-input v-model:value="formState.odk1" placeholder="SimK" suffix="D" />
            </a-form-item>
            <a-form-item label="K值(K2)" name="odk2">
              <a-input v-model:value="formState.odk2" placeholder="SimK" suffix="D" />
            </a-form-item>
            <a-form-item label="前房深度(ACD)" name="odacd">
              <a-input v-model:value="formState.odacd" placeholder="include CCT" suffix="mm" />
            </a-form-item>
            <a-form-item label="目标屈光度(Target)" name="odtarget">
              <a-input v-model:value="formState.odtarget" placeholder="目标屈光度(Target)" suffix="D" />
            </a-form-item>
            <a-form-item label="A常数(A constant)" name="odaConstant">
              <a-input v-model:value="formState.odaConstant" placeholder="优化后的光学A常数" />
            </a-form-item>
            <a-form-item label="晶体厚度(LT)">
              <a-input v-model:value="formState.odlt" suffix="mm" />
            </a-form-item>
            <a-form-item label="角膜厚度(CCT)">
              <a-input v-model:value="formState.odcct" suffix="um" />
            </a-form-item>
            <a-form-item label="角膜直径(WTW)">
              <a-input v-model:value="formState.odwtw" suffix="mm" />
            </a-form-item>
          </div>

          <div>
            <div class="eye" v-if="computer">左眼 <span>(OS)</span></div>
            <a-divider orientation="left" v-else>左眼(OS)</a-divider>
            <a-form-item label="屈光指数(Index)" required>
              <a-input v-model:value="formState.refractiveIndex" disabled />
            </a-form-item>
            <a-form-item label="眼轴长(L)" name="osal">
              <a-input v-model:value="formState.osal" placeholder="光学眼轴长" suffix="mm" />
            </a-form-item>
            <a-form-item label="K值(K1)" name="osk1">
              <a-input v-model:value="formState.osk1" placeholder="SimK" suffix="D" />
            </a-form-item>
            <a-form-item label="K值(K2)" name="osk2">
              <a-input v-model:value="formState.osk2" placeholder="SimK" suffix="D" />
            </a-form-item>
            <a-form-item label="前房深度(ACD)" name="osacd">
              <a-input v-model:value="formState.osacd" placeholder="include CCT" suffix="mm" />
            </a-form-item>
            <a-form-item label="目标屈光度(Target)" name="ostarget">
              <a-input v-model:value="formState.ostarget" placeholder="目标屈光度(Target)" suffix="D" />
            </a-form-item>
            <a-form-item label="A常数(A constant)" name="osaConstant">
              <a-input v-model:value="formState.osaConstant" placeholder="优化后的光学A常数" />
            </a-form-item>
            <a-form-item label="晶体厚度(LT)">
              <a-input v-model:value="formState.oslt" suffix="mm" />
            </a-form-item>
            <a-form-item label="角膜厚度(CCT)">
              <a-input v-model:value="formState.oscct" suffix="um" />
            </a-form-item>
            <a-form-item label="角膜直径(WTW)">
              <a-input v-model:value="formState.oswtw" suffix="mm" />
            </a-form-item>
          </div>
        </div>

        <a-divider> </a-divider>
        <div v-if="computer" class="note">
          <a-form-item label=" " :wrapper-col="{ span: 24 }">
            <span> {{ modeText }} </span>
          </a-form-item>

          <div style="display: flex; justify-content: center; width: 100%">
            <a-space>
              <a-button type="primary" @click="handleCalculate">计算(count)</a-button>
              <a-button type="primary" @click="handleResetData"> 重置(reset) </a-button></a-space>
          </div>
        </div>
        <div v-else>
          <a-form-item label=" " :wrapper-col="{ span: 24 }">
            <span> {{ modeText }} </span>
            <a-button type="primary" @click="handleCalculate" style="margin-top: 10px">开始计算</a-button>
          </a-form-item>
        </div>
      </a-form>
    </a-layout-content>
  </div>
</template>

<script setup>
import { Toast, isComputer } from "@/utils";
import { reactive, ref, watch, computed } from "vue";
import { useRouter, useRoute } from "vue-router";

const router = useRouter();
const route = useRoute();

const modeText = computed(() => {
  if (selectMode.value === "1") {
    return "(此公式不适用于角膜屈光手术后的IOL计算)";
  }
  if (selectMode.value === "2") {
    return "不适用于RK术后 Don't for Post RK Surgery";
  }
});

const renderSelectMode = computed(() => {
  if (selectMode.value === "1") {
    return "公式一(常规眼)";
  }
  if (selectMode.value === "2") {
    return "公式二(屈光术后)";
  }
});

const computer = isComputer();

const selectMode = ref("1");
const showSelectList = ref(false);

const handlePageClick = (e) => {
  if (e.srcElement.dataset.select === undefined) {
    showSelectList.value = false;
  }
}

const handleSelectMode = (mode) => {
  selectMode.value = mode;
  showSelectList.value = false;
}

const formState = reactive({
  name: "",
  age: "",
  id: "",
  Surgeon: "",
  refractiveIndex: "1.3375",
  odal: "",
  odwtw: "",
  odcct: "",
  odlt: "",
  odaConstant: "",
  odtarget: "0",
  odacd: "",
  odk2: "",
  odk1: "",
  osal: "",
  oswtw: "",
  oscct: "",
  oslt: "",
  osaConstant: "",
  ostarget: "0",
  osacd: "",
  osk2: "",
  osk1: "",
});

const rules = {
  odal: [{ required: true, message: "", trigger: "blur" }],
  odk1: [{ required: true, message: "", trigger: "blur" }],
  odk2: [{ required: true, message: "", trigger: "blur" }],
  odacd: [{ required: true, message: "", trigger: "blur" }],
  odtarget: [{ required: true, message: "", trigger: "blur" }],
  odaConstant: [{ required: true, message: "", trigger: "blur" }],
  osal: [{ required: true, message: "", trigger: "blur" }],
  osk1: [{ required: true, message: "", trigger: "blur" }],
  osk2: [{ required: true, message: "", trigger: "blur" }],
  osacd: [{ required: true, message: "", trigger: "blur" }],
  ostarget: [{ required: true, message: "", trigger: "blur" }],
  osaConstant: [{ required: true, message: "", trigger: "blur" }],
};

const handleCalculate = () => {
  const testNumber = (value) => {
    return /^-?\d+(\.\d+)?$/.test(value);
  };
  Object.keys(formState).forEach((key) => {
    if (formState[key] && !testNumber(formState[key])) {
      if (key === "name" || key === "age" || key === "id" || key === "Surgeon") {
        return;
      }
      formState[key] = "";
    }
  });

  const odParams = [
    formState.refractiveIndex,
    formState.odal,
    formState.odk1,
    formState.odk2,
    formState.odacd,
    formState.odtarget,
    formState.odaConstant,
  ];
  const osParams = [
    formState.refractiveIndex,
    formState.osal,
    formState.osk1,
    formState.osk2,
    formState.osacd,
    formState.ostarget,
    formState.osaConstant,
  ];

  const odParamsValid = odParams.every((param) => param !== "");
  const osParamsValid = osParams.every((param) => param !== "");

  if (!odParamsValid && !osParamsValid) {
    Toast(
      "error",
      "输入参数不全, 请检查必填的输入参数( invalid input, check your input please )",
      3
    );
    return;
  }

  router.push({
    path: "/iolresult",
    query: {
      calc: JSON.stringify({
        od: { valid: odParamsValid, params: odParams },
        os: { valid: osParamsValid, params: osParams },
        mode: selectMode.value,
        userInfo: {
          name: formState.name,
          age: formState.age,
          id: formState.id,
          Surgeon: formState.Surgeon,
        },
      }),
    },
  });
};

const handleResetData = () => {
  Object.keys(formState).forEach((key) => {
    formState[key] = "";
  });
  formState.refractiveIndex = "1.3375";
  formState.odtarget = "0";
  formState.ostarget = "0";
};

watch(
  () => route,
  (val) => {
    if (val.path === "/calculate" && val.query.type === "new") {
      handleResetData();
    }
  },
  {
    deep: true,
  }
);
</script>

<style lang="less" scoped>
.ant-layout-header {
  padding: 0 10px;
  border-bottom: 1px solid #eee;
  margin-bottom: 1px;
  display: flex;
  justify-content: space-between;
  background: linear-gradient(135deg, #35b7ad 10%, #abdcff);
  color: #fff;
  font-size: 15px;
  font-weight: 600;

  span {
    color: #f5222d;
    font-size: 12px;
    margin-left: 10px;
    font-weight: 500;
    background-color: rgb(255 255 255 / 30%);
    border-radius: 5px;
    padding: 5px;
  }

  .right {
    font-weight: 700;
    font-size: 15px;
    color: #5ABEBF;
    letter-spacing: 1px;
    cursor: pointer;
    position: relative;
    top: 0.33rem;
    width: 4.36rem;
    height: 0.9rem;
    background: #FFFFFF;
    border-radius: 0.1rem;
    line-height: 0.9rem;
    .select {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .select-icon {
      width: 0.46rem;
      height: 0.46rem;
      background: url('../../assets/img/tabbar/arrow.png');
      background-size: 100% 100%;
      margin-left: 6px;
    }

    .select-list {
      position: absolute;
      top: 0.95rem;
      width: 4.36rem;
      height: 0px;
      background: #fff;
      border-radius: 4px;
      font-size: 13px;
      color: #525252;
      line-height: 34px;
      text-align: center;
      box-shadow: 0 0 2px 0 #ccc;
      text-shadow: none;
      transition: all 0.15s ease-in-out;
      overflow: hidden;
      z-index: 99;

      .active {
        background: #F3F3F3;
      }
    }

    .show {
      height: 1.8rem;
    }

  }
}

.custom-form .ant-form-item {
  width: 100%;
  text-align: left;
  margin-top: 10px;
}

.custom-form .ant-divider-horizontal.ant-divider-with-text-left:before,
.custom-form .ant-divider-horizontal.ant-divider-with-text-left:after {
  top: 0%;
}

/deep/ .ant-form-item-explain,
.ant-form-item-extra {
  min-height: 0px;
}

.ant-form-inline .ant-form-item {
  display: inline-block;
  margin-right: 16px;
  margin-bottom: 10px;
}

.bo-wrapper {
  height: 100vh;
  overflow-y: scroll;
  padding-bottom: 50px;
}

.bo-wrapper-pc {
  .ant-layout-header {
    height: 0.42rem;
    line-height: 0.42rem;
    padding-left: 0.52rem;
    padding-right: 0.28rem;
    font-size: 0.17rem;

    span {
      font-weight: 400;
      font-size: 0.09rem;
      color: #ffffff;
      background: none;
    }

    .right {
      font-weight: 500;
      font-size: 0.08rem;
      color: #5ABEBF;
      cursor: pointer;
      position: absolute;
      left: 1.5rem;
      top: 0.08rem;
      width: 1.14rem;
      height: 0.27rem;
      background: #FFFFFF;
      border-radius: 8px 8px 8px 8px;
      line-height: 0.27rem;
      text-align: center;
      padding: 0 6px 0 16px;

      .select {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .select-icon {
        width: 0.15rem;
        height: 0.15rem;
        background: url('../../assets/img/tabbar/arrow.png');
        background-size: 100% 100%;
        margin-left: 0.06rem;
      }

      .select-list {
        position: absolute;
        top: 0.28rem;
        left: 0;
        width: 1.14rem;
        height: 0rem;
        background: #fff;
        border-radius: 0.03rem;
        font-size: 0.08rem;
        color: #525252;
        line-height: 0.29rem;
        text-align: center;
        box-shadow: 0 0 2px 0 #ccc;
        text-shadow: none;
        transition: all 0.15s ease-in-out;
        overflow: hidden;

        .active {
          background: #F3F3F3;
        }
      }

      .show {
        height: 0.58rem;
      }

    }


  }

  .params-wrapper {
    display: flex;
    padding: 0 1.88rem;
    justify-content: space-between;
    width: 100%;

    /deep/ .ant-form-item-label>label {
      font-size: 0.07rem;
    }

    /deep/ .ant-form-item {
      font-size: 0.07rem;
    }

    .params-space {
      margin-right: 0.74rem;
    }

    .eye {
      font-size: 0.13rem;
      color: #333333;
      line-height: 0.18rem;
      letter-spacing: 1px;
      font-weight: bold;
      margin-bottom: 0.16rem;

      span {
        font-weight: 400;
        font-size: 0.07rem;
        color: #333333;
        line-height: 0.1rem;
        letter-spacing: 1px;
      }
    }
  }

  .user-info {
    display: flex;
    justify-content: space-between;
    padding: 0 1.88rem;
    width: 100%;

    div {
      display: flex;
      letter-spacing: 1px;
      font-size: 0.07rem;
      align-items: center;
      margin-top: 0.12rem;

      ::v-deep input {
        text-align: center;
        border: none;
        border-bottom: 1px solid #999999;
        width: 0.75rem;
        font-size: 0.07rem;
      }

      ::v-deep .ant-input:focus {
        box-shadow: none;
      }
    }
  }

  .note {
    padding: 0 0.8rem;
    width: 100%;
    font-size: 0.07rem;
  }

  button {
    font-size: 0.07rem;
    height: 0.16rem;
  }
}
</style>
